import React from 'react';
import { FadeIn } from './FadeIn';
import { AlertCircle } from 'lucide-react';
export function AgitationSection() {
  const questions = ['¿Cuántas veces esta semana armaste una historia clínica completa desde cero?', '¿Cuántos presupuestos tardaste más en escribir que en explicarle al dueño?', "¿Cuántas veces dijiste 'te mando el resumen' y lo escribiste a las 11 de la noche?", '¿Cuántos planes de vacunación explicaste de palabra porque no tenías nada listo para entregar?'];
  return <section className="py-12 md:py-20 px-4 max-w-4xl mx-auto" data-id="element-14">
      <FadeIn data-id="element-15">
        <h2 className="text-2xl md:text-4xl font-black text-brand-dark text-center mb-10 md:mb-14" data-id="element-16">
          ¿Te suena familiar alguna de estas situaciones?
        </h2>
      </FadeIn>

      <div className="space-y-4 md:space-y-6 mb-12 md:mb-16" data-id="element-17">
        {questions.map((q, i) => <FadeIn key={i} delay={i * 0.1} data-id="element-18">
            <div className="bg-brand-white border border-brand-border rounded-xl p-5 md:p-6 flex gap-4 items-start shadow-sm hover:shadow-md transition-shadow" data-id="element-19">
              <AlertCircle className="text-brand-gold shrink-0 mt-0.5 w-6 h-6 md:w-7 md:h-7" data-id="element-20" />
              <p className="text-lg md:text-xl text-brand-dark font-medium leading-relaxed" data-id="element-21">
                {q}
              </p>
            </div>
          </FadeIn>)}
      </div>

      <FadeIn delay={0.5} data-id="element-22">
        <div className="text-center max-w-3xl mx-auto bg-brand-green/5 p-8 md:p-10 rounded-2xl border border-brand-green/20" data-id="element-23">
          <p className="text-lg md:text-2xl text-brand-dark font-medium leading-relaxed" data-id="element-24">
            No es que seas desorganizada. Es que nadie te dio las herramientas.
            En la facultad te enseñaron a diagnosticar. A documentar, tuviste
            que aprenderlo sola. <br className="hidden md:block" data-id="element-25" />
            <span className="font-black text-brand-green mt-2 inline-block" data-id="element-26">
              Hasta ahora.
            </span>
          </p>
        </div>
      </FadeIn>
    </section>;
}